import { PortionSize } from '../../../../enums/PortionSize';

export const defaultPageSize = PortionSize.Five;
